export const FIELD_MAPPINGS = {
  period: 'periodName',
  subledgeraccount: 'slAccount',
  slview: 'slView',
  lifecyclemap: 'lifecycleMap',
};

export const MIN_COLUMNS_NUMBER = 4;
export const MAX_COLUMNS_NUMBER = 4;
